import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { Helmet } from '@/components/base/Helmet';

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "亚洲自拍和欧美自拍有什么主要区别？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "亚洲自拍更注重皮肤质感的呈现，追求「水光肌」般的通透感，色调偏向柔和温暖。而欧美自拍通常更强调轮廓感和立体感，色调对比度更高。"
      }
    },
    {
      "@type": "Question",
      "name": "新手自拍最应该先学什么？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "新手自拍最应该先学习三个基础技能：光线利用、构图基础（三分法和中央对称）、角度选择。这三样基本功扎实了，自拍水平自然就会大幅提升。"
      }
    },
    {
      "@type": "Question",
      "name": "什么手机最适合拍自拍？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "2026年适合自拍的手机，建议关注前置摄像头像素不低于2000万、支持自动对焦、光圈在f/2.0及以上。旗舰机型的前置拍摄效果普遍出色，中端机型性价比更高。"
      }
    },
    {
      "@type": "Question",
      "name": "自拍时如何选择合适的滤镜？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "选择滤镜的核心原则是适合自己肤色。亚洲肤色偏黄，建议选择暖色调滤镜来中和肤色。韩系滤镜清透柔和的色调非常适合亚洲肤色，滤镜强度建议控制在50%以下。"
      }
    },
    {
      "@type": "Question",
      "name": "室内自拍光线不够怎么办？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "室内自拍光线不足有多种解决方案：利用窗边自然光、投资环形灯（200元起）、使用屏幕补光功能、台灯前加白色薄布柔化光线。最经济有效的方法是充分利用自然光。"
      }
    },
    {
      "@type": "Question",
      "name": "网红自拍风格应该怎么学习？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "学习网红自拍风格建议从三个方面入手：关注喜欢的网红分析共同特点、选择一种风格进行模仿练习、在模仿基础上加入自己特点形成独特风格。小红书和抖音有大量教程可参考。"
      }
    }
  ]
};

export default function Home() {
  return (
    <>
      <Helmet
        title="亚洲自拍完全指南：技巧、设备与风格攻略"
        description="探索亚洲自拍的完整世界——从专业拍摄技巧、热门滤镜风格，到最佳自拍设备推荐与构图秘诀。无论你是自拍新手还是进阶玩家，本页为你提供亚洲自拍文化最全面的实用指南，助你拍出令人惊艳的个人写真与日常记录。"
        keywords="亚洲自拍,亚洲自拍技巧,自拍构图教程,亚洲美妆自拍,手机自拍滤镜推荐,自拍打光方法,亚洲网红自拍风格"
        canonical="https://ahpinxing.cn"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "亚洲自拍完全指南",
            "url": "https://ahpinxing.cn",
            "description": "探索亚洲自拍的完整世界",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://ahpinxing.cn/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "亚洲自拍完全指南：技巧、设备与风格攻略",
            "url": "https://ahpinxing.cn",
            "isPartOf": {
              "@type": "WebSite",
              "name": "亚洲自拍完全指南"
            }
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqSchema),
        }}
      />
      <Navbar />
      <ScrollToTop />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}